"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRENGTH_MESSAGE = exports.STRENGTH_BARS_COUNT = exports.STRENGTH = exports.SCORE_STRENGTH = exports.MIN_PASSWORD_LENGTH = exports.BARS_COUNT = void 0;
const BARS_COUNT = exports.BARS_COUNT = 4;
const MIN_PASSWORD_LENGTH = exports.MIN_PASSWORD_LENGTH = 10;
const STRENGTH = exports.STRENGTH = {
  NONE: 'none',
  WEAK: 'weak',
  ACCEPTED: 'accepted',
  STRONG: 'strong',
  PERFECT: 'perfect'
};
const STRENGTH_BARS_COUNT = exports.STRENGTH_BARS_COUNT = {
  [STRENGTH.NONE]: 0,
  [STRENGTH.WEAK]: 1,
  [STRENGTH.ACCEPTED]: 2,
  [STRENGTH.STRONG]: 3,
  [STRENGTH.PERFECT]: 4
};
const STRENGTH_MESSAGE = exports.STRENGTH_MESSAGE = {
  [STRENGTH.NONE]: 'password_strength_weak',
  [STRENGTH.WEAK]: 'password_strength_weak',
  [STRENGTH.ACCEPTED]: 'password_strength_accepted',
  [STRENGTH.STRONG]: 'password_strength_strong',
  [STRENGTH.PERFECT]: 'password_strength_perfect'
};
const SCORE_STRENGTH = exports.SCORE_STRENGTH = {
  0: STRENGTH.NONE,
  1: STRENGTH.WEAK,
  2: STRENGTH.ACCEPTED,
  3: STRENGTH.STRONG,
  4: STRENGTH.PERFECT
};